<template>
  <div class="mr-10">
    <v-card flat class="mt-5">
      <v-card-title>
        <h6 class="primary--text">Liste des logs</h6>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>

        <!-- <v-btn rounded color="primary" class="text-capitalize">
          <export-excel
            :data = "logs"
            name = "Chains.xls"
            :export-fields ="logs_fields">
            Exporter
            <v-icon right>mdi-share-outline</v-icon>
          </export-excel>
        </v-btn> -->
        <!-- <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Rechercher un maillon"
          single-line
          solo
          hide-details>
        </v-text-field> -->


        <v-select multiple v-model="search" :items="tables" item-text="name" item-value="value" label="Tables"
          solo></v-select>


      </v-card-title>
    </v-card>

    <v-data-table v-if="logs" :headers="headers" :items="logs" :loading="loading" loading-text="Loading..." show-select
      :page.sync="currentPage" :server-items-length="logTotalItems" :items-per-page.sync="rowsPerPageItems"
      :footer-props="footerProps" class="elevation-1">
      <template v-slot:item.action="{ item }">
        <v-icon small @click="showLog(item)">
          mdi-eye-outline
        </v-icon>
      </template>
    </v-data-table>

  </div>
</template>

<script>
import Permissions from '~/mixins/Permissions';
export default {
  name: 'logs-page',
  mixins: [Permissions],
  data: () => ({
    loading: false,
    search: ['App\\Models\\Actor', 'App\\Models\\Event'],
    headers: [
      { text: 'Id', value: 'id' },
      { text: 'Description', value: 'description' },
      { text: 'Modifié par', value: 'causer.username' },
      { text: 'Acteur modifié', value: 'subject.full_name' },
      { text: 'Evènement modifié', value: 'subject.name' },
      { text: 'Date', value: 'created_at' },
      { text: 'Action', value: 'action', sortable: false }
    ],
    tables: [
      { name: 'Acteur', value: 'App\\Models\\Actor' },
      { name: 'Evènement', value: 'App\\Models\\Event' }
    ],
    logs_fields: {
      "Logs": "name",
    },
    payload: {
      query: { models: ['App\\Models\\Actor', 'App\\Models\\Event'] }
    },
    footerProps: {
      "items-per-page-options": [5, 10, 15, 30, 50, 100, 500],
      "items-per-page-text": "Lignes par page",
    },
  }),
  watch: {
    'search'(newVal, oldVal) {
      if (newVal.length != 0) {
        this.payload.query.models = newVal
        this.fetchUtils();
      } else {
        this.payload.query.models = ['App\\Models\\Actor', 'App\\Models\\Event']
        this.fetchUtils();
      }

    },
  },
  created() {
    this.$checkPermission('access logs')
    this.payload.page = 1;
    this.payload.rowsPerPage = 15;
    this.loading = false
    this.fetchUtils();
  },

  computed: {
    logs() { return this.$store.getters.logs; }, rowsPerPageItems: {
      get: function () {
        return this.$store.getters.rowsPerPageItems;
      },

      set: function (value) {
        this.payload.rowsPerPage = value;
        this.fetchUtils();
      },
    },
    currentPage: {
      get: function () {
        return this.$store.getters.current_page;
      },

      set: function (value) {
        this.payload.page = value;
        this.fetchUtils();
      },
    },
    pagination() {
      return this.$store.getters.pagination;
    },

    logTotalItems() {
      return this.$store.getters.logTotalItems;
    },
  },

  methods: {
    fetchUtils() {
      this.loading = true;
      this.$store.dispatch("fetchLogs", this.payload).then((result) => {
        this.loading = false;
      });
    },
  }
};
</script>

<style scoped>
.couleur-orange {
  color: rgb(255, 152, 0);

  font-size: 1.2em;
}

.white-couleur {
  color: white;
}
</style>




// WEBPACK FOOTER //
// resources/assets/js/pages/logs/index.vue